import { render, staticRenderFns } from "./AdminRegions.vue?vue&type=template&id=00942b9a"
import script from "./AdminRegions.vue?vue&type=script&lang=js"
export * from "./AdminRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports